import classNames from 'classnames';
import React from 'react';

import { getHiddenTypeClassName, ViewTypesToHide } from '../getLayoutClassnames';

type Props<CType extends React.ElementType = 'section'> = {
    /**
     * Polymorph the component to another html tag
     * @default article
     */
    as?: CType;
    /**
     * add type 'mobile'|'desktop' to array to hide on that type of device
     * @default undefined
     */
    hideOn?: ViewTypesToHide;
} & React.PropsWithChildren &
    React.ComponentPropsWithoutRef<CType>;

const LayoutItem: React.FC<Props> = ({ children, className, as, hideOn, ...rest }) => {
    const Component = as ?? 'section';
    const hideClassName = getHiddenTypeClassName(hideOn);
    return (
        <Component className={classNames('sgw-layout-item', className, hideClassName)} {...rest}>
            {children}
        </Component>
    );
};

export default LayoutItem;
